import { useFormat } from 'vivat';

const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    code: {
      name: 'รหัสสินค้า',
      width: '8rem',
    },
    refCode: {
      name: 'รหัสอ้างอิง',
      width: '8rem',
    },
    name: {
      name: 'รายการสินค้า',
      width: '1fr',
    },
    unit: {
      name: 'หน่วย',
      width: '6rem',
    },
    productGroup: {
      name: 'ประเภท',
      width: '10rem',
      filter(val: any, row: any) {
        if (val) {
          return row.item?.productGroup?.name;
        }
        return '-';
      },
    },
    weightPerUnit: {
      name: 'นำ้หนัก/หน่วย',
      width: '6rem',
      class: 'text-right',
    },
    deliveryFeePerUnit: {
      name: 'ค่าจัดส่ง/หน่วย(บาท)',
      width: '10rem',
      class: 'text-right',
    },
    dimensional: {
      name: 'ปริมาตร(กxยxส)',
      width: '8rem',
      class: 'mr-2 text-right',
      // eslint-disable-next-line
      filter(val: any, row: any) {
        return `${row.item.width} x ${row.item.length} x ${row.item.height}`;
      },
    },
    updatedAt: {
      name: 'เคลื่อนไหวล่าสุด',
      width: '14rem',
      filter(val: any) {
        return useFormat.date(val).displayShortThaiDateTime();
      },
    },
  },
  sortable: [
  ],
};
